import React from 'react';

import { useStateValue } from '../hooks/useState';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/Header/Header';
import { BackBox } from '../components/BackBox/BackBox';
import { DescriptionBox } from '../components/DescriptionBox/DescriptionBox';
import { Footer } from '../components/Footer/Footer';
import { routes } from '../constants/constants';
import { useLocationPrepare } from '../hooks/useLocationPrepare';
import { SMS } from '../components/sms/SMS';
import styled from 'styled-components';
import { useRouter } from '../react-router-hooks';
import { TuevBadge } from '../components/tuev/TuevBadge';

const Image = styled.img`
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;

const ContainerMain = styled.div`
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  @media (max-width: 1500px) {
    justify-content: center;
  }
`;

export const RightImageContainer = styled.div`
  @media (max-width: 1500px) {
    width: auto;
  }
  width: 45vw;
  max-width: 506px;
`;

export const SMSScreen = () => {
  useLocationPrepare();

  const { t } = useTranslation();
  const [{ uuid, responseURI }] = useStateValue();
  const { location } = useRouter();

  return (
    <div className="root">
      <Header />

      <ContainerMain id="main" className="main">
        <div
          style={{
            flexGrow: 1,
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <BackBox
              to={{
                pathname:
                  (location && location.state && location.state.prevRoute) ||
                  routes.QR,
                state: {
                  isIFrame:
                    location && location.state && location.state.isIFrame
                }
              }}
              text={t('Back to QR code')}
            />

            <DescriptionBox
              title={t('Get the Nect app and start your identification.')}
              textElement={
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: 640
                  }}
                >
                  <p
                    style={{
                      fontSize: 18,
                      lineHeight: '150%',
                      letterSpacing: '0.04em'
                    }}
                  >
                    {t(
                      'Get the Nect app by sending an SMS link to your smartphone. Nect app is available on both iPhone and Android phone.'
                    )}
                  </p>
                  <SMS />
                </div>
              }
            />
            <div
              style={{ marginTop: 20, display: 'flex', alignItems: 'flex-end' }}
            ></div>
          </div>

          <RightContainer>
            <RightImageContainer>
              <Image
                alt="Start Identification via SMS"
                src={require('../assets/sms-signup.png')}
              />
            </RightImageContainer>
          </RightContainer>
        </div>
        <div
          style={{
            marginTop: 20,
            display: 'flex',
            alignItems: 'flex-end',
            flex: 1,
            justifyContent: 'flex-end'
          }}
        >
          <TuevBadge />
        </div>
      </ContainerMain>
      <Footer />
    </div>
  );
};
